import { RobotoFont } from '../../styles/fonts';
import { Accordion, AccordionSummary, Box, Typography, styled } from '@mui/material';

export const StyledTitleContainer = styled(AccordionSummary)(({ theme }) => ({
  padding: '0',
  '.MuiTypography-root': {
    height: '24px',
    fontSize: '20px',
    lineHeight: '24px',
    letterSpacing: '1px',
    padding: 0,
    display: 'flex',
    textTransform: 'uppercase',
    color: '#181818',
    alignItems: 'center',
  },
  '.MuiAccordionSummary-content': {
    margin: 0,
  },
  '.MuiPaper-root-MuiAccordion-root.Mui-expanded': {
    margin: 0,
  },
  '.MuiAccordionSummary-content.Mui-expanded': {
    position: 'relative',
    margin: 0,
    '&::before': {
      context: '""',
      width: '100%',
      height: '2px',
      background: 'red',
      top: 0,
      position: 'absolute',
    },
  },
}));

export const StyledContainer = styled(Accordion)(({ theme }) => ({
  boxShadow: 'none !important',

  '.MuiAccordionDetails-root': {
    padding: '0',
  },
  '.MuiAccordion-root:before': {
    opacity: 0,
  },
  '.MuiAccordionSummary-root': {
    padding: '0',
  },
}));

export const StyledFilterCountWrapper = styled('div')(({ theme }) => ({
  marginLeft: '12px',
  display: 'flex',
  gap: '14px',
  alignItems: 'center',
  fonSize: '16px',
  lineHeight: '20px',
  '& > span:hover': {
    textDecoration: 'underline',
  },
}));

export const StyledProductTitle = styled(Typography)(({ theme }) => ({
  fontFamily: `${RobotoFont.style.fontFamily}, sans-serif !important`,
  fontSize: '16px !important',
  lineHeight: '20px !important',
  letterSpacing: '2px !important',
  margin: '16px 0 !important',
}));
export const StyledTitle = styled(Typography)(({ theme }) => ({
  margin: 0,
}));

export const StyledCollapseFilter = styled(Box)(({ theme }) => ({
  '.MuiPaper-root-MuiAccordion-root.Mui-expanded': {
    margin: 0,
  },
  '.MuiAccordionSummary-root.Mui-expanded': {
    minHeight: 'fit-content',
  },
  '.MuiAccordionSummary-content.Mui-expanded': {
    margin: '14px 0',
  },

  '@media only screen and (max-width: 768px)': {
    marginRight: 0,
  },
}));
